
import React from 'react';
import {Action, Spinner} from "../../funcs/utils";
import {ChartRt} from "../../components/chart_rt";
import {identity_matrix} from "../../../lib/matrix";
import {QueueType} from "../../../lib/proto/queue_proto";
import {string_cmp} from "../../../lib/js-utils";
import {sprintf} from "sprintf-js";

class Portfolio extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      group_index: 0,
    };
    this.containerRef = React.createRef();
    this.view_matrix = identity_matrix();
    this.view_matrix_inv = identity_matrix();

    this.group_data = [
      {
        title: "Portfolio",
        data: null,
      },
      {
        title: "Cash",
        data: null,
      }
    ]
  }

  componentDidMount() {
    this.setState({
      width: this.containerRef.current.offsetWidth,
      height: this.containerRef.current.offsetHeight,
    })
  }

  get_portfolio = () => {
    const username = this.props.username;
    const index = this.props.index;

    if (this.props.portfolio
      && this.props.portfolio[username]
      && this.props.portfolio[username][index]) {
      return this.props.portfolio[username][index].portfolio;
    }
    return null;
  }

  get_events = () => {
    const username = this.props.username;
    const index = this.props.index;

    if (this.props.portfolio
      && this.props.portfolio[username]
      && this.props.portfolio[username][index]) {
      return this.props.portfolio[username][index].events;
    }
    return null;
  }

  get_spans = () => {
    const username = this.props.username;
    const index = this.props.index;

    if (this.props.notification[username]
      && this.props.notification[username][index]) {
      return this.props.notification[username][index].span_data;
    }
    return [];
  }

  render_portfolio = () => {
    const portfolio = this.get_portfolio();

    const button_cb = () => {
      this.props.loadPortfolio(this.props.username, this.props.index, this.props.client.chart_colors);
      this.props.loadUserQueueItems(
        this.props.username, this.props.index, QueueType.Rebalance.id);
    }

    if (!portfolio) {
      return (
        <Action onClick={button_cb}>
          Load
        </Action>
      )
    }

    const portfolio_data = [
      {
        color: "#000",
        label: "Portfolio",
        data: portfolio.portfolio,
        lineWidth: 2,
      },
      {
        color: "#1a7bcb",
        label: "Glide Low",
        data: portfolio.glide.map(item => item.glide_low),
        lineWidth: 1
      },
      {
        color: "#1a7bcb",
        label: "Glide High",
        data: portfolio.glide.map(item => item.glide_high),
        lineWidth: 1,
      },
      {
        color: "#1a7bcb",
        label: "Glide",
        data: portfolio.glide.map(item => item.glide),
      },
    ];

    const cash_data = [
      {
        color: "#000",
        label: "Cash",
        data: portfolio.cash,
      },
      {
        color: "#B00",
        label: "Cash Allocation",
        data: portfolio.cashAllocAlgo,
      },
      {
        color: "#0B0",
        label: "Cash Fee",
        data: portfolio.cashFee,
      },
      {
        color: "#00C",
        label: "NOOP",
        data: [],
      },
      {
        color: "#0CC",
        label: "Available to allocate",
        data: portfolio.cashAvail,
      }
    ]

    this.group_data[0].data = portfolio_data;
    this.group_data[1].data = cash_data;

    const rebal_events = this.get_events().filter(ev => ev['detail-type'] === "ACCOUNT_REBALANCE");
    const rebal_lines = rebal_events.map(ev => {
      const date_str = ev.time.split("T")[0];
      return {
        date: date_str,
        color: "#c78d60",
        type: "REBAL",
        bottom_t: 0,
        top_t: 0.1,
        width: 5,
        labels: [ "Rebalanced", date_str ],
        label_t: 0.2,
      }
    });

    const cash_events = this.get_events().filter(ev => ev['detail-type'] === "CASH");
    const cash_lines = cash_events.map(ev => {
      const date_str = ev.time.split("T")[0];
      console.log("ev", ev);
      return {
        date: date_str,
        color: "#34723d",
        type: "CASH",
        bottom_t: 0.9,
        top_t: 1,
        width: 2,
        labels: [ "Cash", sprintf("$%.2f %s", ev.event.detail.cash, date_str) ],
        label_t: 0.8,
      };
    });

    const all_lines = rebal_lines.concat(cash_lines);
    all_lines.sort((a, b) => string_cmp(a.date, b.date));

    const on_group_selected = index => {
      this.setState({
        group_index: index,
      })
    }

    return (
      <ChartRt
        width_px={this.state.width}
        height_px={this.state.height}
        xAxisHeightRem={"2rem"}
        yAxisWidthRem={"3.5rem"}
        topAxisHeightRem={"2rem"}
        vertLines={all_lines}
        spans={this.get_spans()}
        on_span_selected={this.props.on_span_selected}
        on_group_selected={on_group_selected}
        group_data={this.group_data}
        group_index={this.state.group_index}
        sim_days={portfolio.days}/>
    );
  }


  get_loading = () => {
    const username = this.props.username;
    const index = this.props.index;

    if (this.props.portfolio
      && this.props.portfolio[username]
      && this.props.portfolio[username][index]) {
      return this.props.portfolio[username][index].loading;
    }
    return null;

  }

  render = () => {

    const loading = this.get_loading();

    const container_style = {
      border: "1px solid black",
      aspectRatio: "4",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }

    const button_container = {
      marginTop: "1rem",
    }

    const group_name = this.group_data[this.state.group_index].title;
    const title_style = {
      fontSize: "1.4rem",
      fontWeight: "200",
      paddingLeft: "1rem",
      paddingBottom: "0.2rem",
    }
    return (
      <div>
        <div style={title_style}>{group_name}</div>
        <div style={container_style} ref={this.containerRef}>
          { loading && <Spinner size="2rem"/> }
          { !loading && this.render_portfolio() }
        </div>
        <div align={"center"} style={button_container}>
          <Action>
            Download Portfolio XLS
          </Action>
        </div>
      </div>
    )
  }
}

export { Portfolio };
